import {Box, Divider, Grid, Typography} from '@mui/material';
import {PaymentPlanColors, PaymentStatusColors, SupportTierColors} from '../../../styles/colors';
import StyledChip from '../../StyledComponents/StyledChip';
import StyledTitleLink from '../../StyledComponents/StyledTitleLink';

function OrganizationSearchCard({organization}: {organization: any}) {
  const {id, name, plan, support_tier, payment_status, created_at, updated_at} = organization;

  return (
    <Box p={2} pb={1} pt={1}>
      <Grid container>
        <StyledTitleLink name={name} id={id} linkTo={`/organizations/${id}`} />
      </Grid>
      <Grid container>
        <Grid xs={4}>
          <Typography variant="caption" color="text.secondary" style={{marginLeft: '6px'}}>
            Plan
          </Typography>
          <Typography variant="body1" gutterBottom>
            <StyledChip
              size="small"
              label={plan.toString() || ''}
              color={
                PaymentPlanColors[plan as keyof typeof PaymentPlanColors] || PaymentPlanColors.free
              }
            />
          </Typography>
        </Grid>
        <Grid xs={4}>
          <Typography variant="caption" color="text.secondary" style={{marginLeft: '6px'}}>
            Support Tier
          </Typography>
          <Typography variant="body1" gutterBottom>
            <StyledChip
              size="small"
              label={support_tier.toString() || ''}
              color={
                SupportTierColors[support_tier as keyof typeof SupportTierColors] ||
                SupportTierColors.free
              }
            />
          </Typography>
        </Grid>
        <Grid xs={4}>
          <Typography variant="caption" color="text.secondary">
            Payment Status
          </Typography>
          <Typography variant="body1" gutterBottom>
            <StyledChip
              size="small"
              label={payment_status.toString() || ''}
              color={
                PaymentStatusColors[payment_status as keyof typeof PaymentStatusColors] ||
                PaymentStatusColors.active
              }
            />
          </Typography>
        </Grid>
        <Grid xs={3}>
          <Typography variant="caption" color="text.secondary">
            Dates (Created/Updated)
          </Typography>
          <Typography variant="body1" gutterBottom>
            {created_at}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {updated_at}
          </Typography>
        </Grid>
      </Grid>

      <Divider />
    </Box>
  );
}

export default OrganizationSearchCard;
